import { v4 as uuid } from "uuid";
import { handleError } from "../error";
import { history } from "../../store";
import { handleResponse } from "../response";
import { GET_BOOKMARK } from "../../types";
import axios from "axios";
export const componentLoad = routeProps => async dispatch => {
    try {
        const { component, verb, componentID, code } = routeProps;

        let newUrl = `/app/${component}`;

        if (verb) {
            newUrl += `/${verb}`;
        }
        if (componentID) {
            newUrl += `/${componentID}`;
        }
        //  Recent Visits list will max at 10 items

        //   Get Default visits from local storage if undefined
        let urlList = JSON.parse(localStorage.getItem("act")) || [];

        //  If url or code already exist in the list, bail out.
        const urlExist = urlList.some(url => url.url === newUrl);
        const codeExist = urlList.some(url => url.code === code);
        if (urlExist || codeExist) {
            return;
        }

        //  If length is 0 or less then 10, We'll add a new item into the list
        if (urlList?.length === 0 || !urlList) {
            urlList = [
                {
                    id: uuid(),
                    ...routeProps,
                    url: newUrl
                }
            ];
        }
        else if (urlList.length < 10) {
            urlList = [
                ...urlList,
                {
                    id: uuid(),
                    ...routeProps,
                    url: newUrl
                }
            ];
        }
        else if (urlList.length >= 10) {
            //  If length is 10 or more, we'll take out the first item in the array `The oldest one`
            urlList.shift();
            urlList = [
                ...urlList,
                {
                    id: uuid(),
                    ...routeProps,
                    url: newUrl
                }
            ];
        }

        //  Set data to the localStorage as a String
        localStorage.setItem("act", JSON.stringify(urlList));
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const addBookmark = ({ name, code }) => async dispatch => {
    try {
    // console.log("addBookmark");
        const result = await axios.get(`/bookmarks/get?reactAPI=true`);

        dispatch(handleResponse(result));

        let bookmarks = result.data.bookmarks;
        // let bookmarks = localStorage.getItem("bookmarks");
        const pathName = history.location.pathname;
        if (!bookmarks) {
            //  INSERT NEW BOOKMAKRS
            const uri = JSON.stringify([
                {
                    uri: pathName,
                    name,
                    code
                }
            ]);
            // localStorage.setItem("bookmarks", uri);

            let postUrl = "/bookmarks/update/";
            let postData = {
                reactAPI: true,
                data: uri
            };

            const response = await axios.post(postUrl, postData);

            dispatch(handleResponse(response));

            await dispatch({
                type: GET_BOOKMARK,
                payload: JSON.parse(response.data.bookmarks)
            });
        }
        else {
            //  APPEND NEW BOOKMARKS
            const uri = JSON.parse(bookmarks);
            if (uri.find(({ uri }) => uri === pathName)) {
                return;
            }
            uri.unshift({
                uri: pathName,
                name,
                code
            });
            // localStorage.setItem("bookmarks", JSON.stringify(uri));

            let postUrl = "/bookmarks/update/";
            let postData = {
                reactAPI: true,
                data: JSON.stringify(uri)
            };

            const response = await axios.post(postUrl, postData);

            dispatch(handleResponse(response));
            await dispatch({
                type: GET_BOOKMARK,
                payload: JSON.parse(response.data.bookmarks)
            });
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const getBookmark = () => async dispatch => {
    try {
        await dispatch(getBookmarksFromLocalStorage());
        // console.log("getBookmark");
        const result = await axios.get(`/bookmarks/get?reactAPI=true`);

        dispatch(handleResponse(result));

        if (result.data.bookmarks) {
            let bookmarks = JSON.parse(result.data.bookmarks);

            await dispatch({
                type: GET_BOOKMARK,
                payload: bookmarks
            });
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const getBookmarksFromLocalStorage = () => async dispatch => {
    try {
        let bookmarks = localStorage.getItem("bookmarks");
        if (bookmarks && String(bookmarks) !== "[]") {
            let postUrl = "/bookmarks/update/";
            let postData = {
                reactAPI: true,
                data: bookmarks,
                storage: true
            };

            const response = await axios.post(postUrl, postData);
            // console.log(response);

            dispatch(handleResponse(response));
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const removeBookmark = () => async dispatch => {
    try {
    // console.log("removeBookmark");
        const result = await axios.get(`/bookmarks/get?reactAPI=true`);
        dispatch(handleResponse(result));
        let currentBookmarks = result.data.bookmarks;
        // const pathName = history.location.pathname;
        if (currentBookmarks) {
            let newBookmark = JSON.stringify(
                JSON.parse(currentBookmarks || []).filter(
                    ({ uri }) => uri !== history.location.pathname
                )
            );

            let postUrl = "/bookmarks/update/";
            let postData = {
                reactAPI: true,
                data: newBookmark
            };

            const response = await axios.post(postUrl, postData);
            dispatch(handleResponse(response));

            let bookmarks = JSON.parse(response.data.bookmarks);

            await dispatch({
                type: GET_BOOKMARK,
                payload: bookmarks
            });
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const clearBookmark = () => async dispatch => {
    try {
    // console.log("clearBookmark");

        let newBookmark = "[]";
        // console.log(newBookmark);

        let postUrl = "/bookmarks/update/";
        let postData = {
            reactAPI: true,
            data: newBookmark
        };

        const response = await axios.post(postUrl, postData);
        // console.log(response);
        dispatch(handleResponse(response));

        let bookmarks = JSON.parse(response.data.bookmarks);

        await dispatch({
            type: GET_BOOKMARK,
            payload: bookmarks
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};